import { MAX_VOLUME } from '@/scenarios/legacy-player/constants/volume';

import Mute from './images/mute.svg';
import Half from './images/half.svg';
import Full from './images/full.svg';

export const getVolumeIcon = (volume: number, isMuted: boolean) => {
    if (volume === 0 || isMuted) {
        return Mute;
    }

    if (volume > MAX_VOLUME / 2) {
        return Full;
    }

    return Half;
};
